<script>
  export let currentPage = 0;
  export let total = 0;
  export let maxPages;
  export let pager;
  export let prevPager;
  
  // this is used in show users admin page
  export let showNextPage = true;
</script>

<div class="pagination">
  <div class="page-btns">
    <button class="btn" disabled={currentPage === 0} on:click={() => {prevPager()}}>
      Previous
    </button>
    {#if total}
    <div class="total">
      <span>Total: {total}</span>
    </div>
    {/if}
    <button class="btn" disabled={currentPage + 1 === maxPages || !showNextPage} on:click={() => {pager()}}>
      Next
    </button>
  </div>
</div>
<style type="text/less">
  .pagination {
    padding: var(--spacing-xs);
  }

  .page-btns {
    display: flex;
    justify-content: space-between;
  }

  .total {
    line-height: var(--line-height);
    align-self: center;
  }

  
</style>
